import React, { useState, useEffect } from "react";
import style from "./index.module.scss";
import Cookies from 'universal-cookie';
import { useDispatch, useSelector } from "react-redux";
import { getIpAddressDatas } from "@/src/redux/actions/user_tracking";
import LandingPageFooter from "../landing/features/success/footerOld/LandingPageFooter";
import LandingOverview from "../landing/features/success/LandingOverview";
import LandingServices from "../landing/features/success/LandingServices";
import LandingProducts from "../landing/features/success/LandingProducts";
import LandingCallToAction from "../landing/features/success/LandingCallToAction";
import LandingLogin from "../landing/features/success/LandingLogin/LandingLogin";
import { callToActionAction, headlineAction, listLayananAction, listProdukAction, listWordStylingAction } from "@/src/redux/actions/login";
import { loginRepository } from "@/src/datas/common/login";
import FallbackHeader from "@/src/components/elements/Headers/fallback/FallbackHeader";

export default function Home({
  id,
}: {
  id: string;
}): JSX.Element {
  const {
    listWordStyling,
    headline, isLoadingHeadline,
    listLayanan, isLoadingListLayanan,
    listProduk, isLoadingListProduk,
    callToAction, isLoadingCallToAction,
  } = useSelector(
    (state: any) => state?.loginPage
  );

  const dispatch = useDispatch()
  const cookie = new Cookies()

  const [state, setState] = useState({
    openLogin: false,
  })

  const clearCacheData = () => {
    caches?.keys()?.then((names) => {
      names?.forEach((name) => {
        caches?.delete(name)
      })
    })
    cookie.remove('user')
    sessionStorage.clear()
    localStorage.clear()
  }

  useEffect(() => {
    clearCacheData()
    dispatch(getIpAddressDatas())
    dispatch(listWordStylingAction());
    dispatch(headlineAction());
    dispatch(listLayananAction());
    dispatch(listProdukAction());
    dispatch(callToActionAction());
  }, [])

  const handleLoginButton = () => {
    setState({ ...state, openLogin: !state.openLogin })
  }

  const handleChangeStateData = (value: any) => {
    setState({ ...state, ...value })
  }

  if (isLoadingHeadline || isLoadingListLayanan || isLoadingListProduk || isLoadingCallToAction) {
    return <FallbackHeader />
  }

  return (
  <>
    {/* section header */}
    <header className={style.header} id="landing-page-header">
      <img
        id={"image-logo-bribrain"}
        className={style.image_header}
        src={`${process.env.NEXT_PUBLIC_IMAGES}/bribrain-logo.svg`}
        alt="logo-header"
      />
    </header>
    {/* end section header */}

    <div className={style.container}>
      <LandingOverview
        headline={headline?.data}
        handleLogin={handleLoginButton}
        listWordStyling={listWordStyling?.data}
      />
      <LandingServices
        services={listLayanan?.data}
        loading={isLoadingListLayanan}
        listWordStyling={listWordStyling?.data}
      />
      <LandingProducts
        showcases={listProduk?.data?.showcase}
        others={listProduk?.data?.logo}
        totalUsecase={listProduk?.data?.total_usecase}
        listWordStyling={listWordStyling?.data}
      />
      <LandingCallToAction
        callToAction={callToAction?.data}
      />
    </div>

    <LandingPageFooter id={`${id}-${process.env.NEXT_PUBLIC_FOOTER}`} />
    {/* modal login */}
    {state.openLogin &&
      <LandingLogin
        staticData={loginRepository}
        stateData={{ loginDrawer: state.openLogin }}
        handleChangeStateData={handleChangeStateData}
      />
    }
    {/* end modal login */}
  </>
  )
}
